/* eslint-disable require-jsdoc */
function isMobile(carousel) {
  return carousel.sliderItems == 2 ? true : false;
}

function isTablet(carousel) {
  return carousel.sliderItems == 4 ? true : false;
}
function isDesktop(carousel) {
  return carousel.sliderItems == 5 ? true : false;
}

function isValid(data) {
  return data != '' && data != 'None' && data != null? true : false;
}
function isHttps(data) {
  const https = data.substring(0, 5) == 'https';
  return https ? true : false;
}
function isHttp(data) {
  const http = data.substring(0, 5) == 'http';
  return http ? true : false;
}
function checkMethod(method) {
  if (method == 'GET') {
    return 'GET';
  }
  if (method == 'POST') {
    return 'POST';
  }
  // console.log('error wrong http method! method given ', method);
  return 'method issue';
}
function removeTrailingStr(data, str) {
  const dataLen = data.length;
  const strLen = str.length;
  const hasTrailingStr = data.substring(dataLen - strLen, dataLen) == str;
  return hasTrailingStr ? data.substring(0, dataLen - strLen) : data;
}
function getEventImage(rawImage) {
  return isValid(rawImage) ? rawImage : '';
}

function hasProp(Obj, propStr) {
  return Obj.hasOwnProperty.call(Obj, propStr) ?
    true : false;
}

const checkImgURL = (imageUrl) => {
  
  return (imageUrl.match(/\.(jpeg|jpg|gif|png)$/) != null);
};

export {isValid, isHttps, isHttp, removeTrailingStr, isDesktop,
  isTablet, isMobile, checkMethod, getEventImage, hasProp, checkImgURL};
